(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("ui"), require("feature-hdfc-portal-download-pdf"));
	else if(typeof define === 'function' && define.amd)
		define("widget-hdfc-portal-compare-overlay", ["base", "core", "ui", "feature-hdfc-portal-download-pdf"], factory);
	else if(typeof exports === 'object')
		exports["widget-hdfc-portal-compare-overlay"] = factory(require("base"), require("core"), require("ui"), require("feature-hdfc-portal-download-pdf"));
	else
		root["widget-hdfc-portal-compare-overlay"] = factory(root["base"], root["core"], root["ui"], root["feature-hdfc-portal-download-pdf"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_140__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition